import React, { useEffect, useMemo, useState } from 'react';
import { connect } from 'redux-zero/react';
import { GlobalCustomCSS } from '@embed/components/common/GlobalCustomCSS';
import { FloatingButton } from '@embed/components/FloatingButton';
import { AppContextType } from '@embed/components/helpers';
import { WidgetWrapper } from '@embed/components/Player3/components/WidgetWrapper';
import { useEmbedAppContext } from '@embed/hooks/useEmbedAppContext';
const positionVerticalValidate = (value) => ({ top: 'top', bottom: 'bottom' }[value] || 'top');
const positionHorizontalValidate = (value) => ({ right: 'right', left: 'left' }[value] || 'right');
const imageExist = (url, success, fail) => {
    const img = new Image();
    img.onload = typeof success === 'function' ? success : () => false;
    img.onerror = typeof fail === 'function' ? fail : () => false;
    img.src = url;
};
const mapStateToProps = ({ appContext, params }) => {
    return {
        appContext,
        params,
    };
};
const FloatingButtonWidget = connect(mapStateToProps)((props) => {
    const { params, actions } = props;
    const appContext = useEmbedAppContext({
        params,
        actions,
        appContextType: AppContextType.EMBED_CHANNEL_BUTTON_CONTEXT_TYPE,
    });
    if (!appContext) {
        return null;
    }
    useEffect(() => {
        actions.setContext({ appContext });
    }, [appContext]);
    const { publisherClient, channel } = appContext;
    useEffect(() => {
        if (publisherClient === null || publisherClient === void 0 ? void 0 : publisherClient.config) {
            actions.fetchedParams({
                fetchedParams: publisherClient.config,
            });
            actions.fetchExperiments({ publisherClient });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [publisherClient]);
    useEffect(() => {
        if (channel === null || channel === void 0 ? void 0 : channel.config) {
            actions.fetchedParams({
                fetchedParams: channel.config,
            });
        }
    }, [channel, actions]);
    useEffect(() => {
        actions.trackEmbedInstance({ appContext });
    }, [appContext.embedInstanceId]);
    const [avatar, setAvatar] = useState();
    const [positionVertical, positionHorizontal] = useMemo(() => (params.placement || '').split('-'), [params.placement]);
    useEffect(() => {
        const icon = `https://fireworktv.com/ch/${params.channel}/avatar`;
        imageExist(icon, () => setAvatar(icon));
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    return (<>
      <GlobalCustomCSS params={params}/>
      <FloatingButton icon={avatar} positionHorizontal={positionHorizontalValidate(positionHorizontal)} positionVertical={positionVerticalValidate(positionVertical)} offsetHorizontal={params.horizontal || 0} offsetVertical={params.vertical || 0} text={params.text || `${params.channel}'s Stories`} channel={params.channel} params={params} appContext={appContext} actions={actions}/>
    </>);
});
export default ({ initialParams, widgetParams }) => (<WidgetWrapper initialParams={initialParams} widgetParams={widgetParams}>
    {(actions) => <FloatingButtonWidget actions={actions}/>}
  </WidgetWrapper>);
